/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa basket cookie
 *
 */
Intesa.BasketCookie = function () {

	/**
	 * Local variables
	 *
	 */
	var basketCookie = this;
	var cookieName = "product";
	var cookieDuration = 30;

	/**
	 * Attributes
	 *
	 */
	this.categoryMap = new Map();
	this.categoryResumeMap = new Map();

	/**
	 * Init component
	 *
	 */
	this.init = function () {

		// get cateogry map
		var preloadedCategory = $(".cart__summary__item[data-category]");
		preloadedCategory.each(function (index, element) {

			var $this = $(element);

			if ($this.is(":visible")) {

				basketCookie.categoryMap.set($this.data("category"), $this.data("itemid"));

			}

		});

		// init categoryResumeMap
		if (localStorage.getItem("categoryResumeMap") && localStorage.getItem("categoryResumeMap") != "[]") {

			basketCookie.categoryResumeMap = new Map(JSON.parse(localStorage.getItem("categoryResumeMap")));

		}

		// secure sign
		$("[data-secure-sign]").click(function (event) {

			// prevent default
			event.preventDefault();

			var bankName = $(this).attr("data-secure-sign"); 	// get the bank
			var urlToBeOpened = $(this).attr("data-url"); 		// get the url

			$.ajax({

				type: "POST",
				url: '/signVerifyBasketCookieServlet/?operation=sign&bankName=' + bankName,
				success: function () {

					// push dataLayer
					var productCookie = basketCookie.getCookie(cookieName);
					if (productCookie) {
						try {
							productCookie = JSON.parse(productCookie);
							window.dataLayer = window.dataLayer || [];
							window.dataLayer.push({
								event: 'crossSelling',
								eventCategory: 'onboarding cart',
								eventAction: 'added to cart',
								productName: productCookie.mainProduct ? productCookie.mainProduct.label : '',
								productFamily: 'CURRENTACCOUNT',
								crossProductName: productCookie.customOffer ? productCookie.customOffer.label : null
							});
						} catch (e) {
							console.error('Datalayer Parse error: unable to parse productCookie');
						}
					}

					// redirect
					if (urlToBeOpened !== null) {
						window.location.href = urlToBeOpened;
					}

				},
				error: function () {

					// console.log( "error secure" ); //do nothing

				}

			});

		});

		// if the cookie trigger is clicked
		$(document).on('click', "*[data-generate-cookie]", function (event) {

			// prevent default
			event.preventDefault();

			// create cookie on main product
			basketCookie.createCookie($(this));

			if ($(this).attr("data-enabled") == "false") return;

			// push add to cart to dataLayer
			var product = $(this).attr("data-c-mainproduct");
			product = basketCookie.getProductInfo(product);

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'addtocart_pp',
				eventCategory: 'onboarding cart',
				eventAction: 'addtocart in PP',
				productFamily: 'CURRENTACCOUNT',
				productName: product.name,
				fullPrice: product.fullPrice,
				discountedPrice: product.discountedPrice,
				pricingType: product.pricingType,
			});

			// generate cookie and sign 
			// this is to have 2 events into the same button			
			var e = $(this).attr("data-generate-and-secure-sign");

			if (e == null || e == undefined || e.trim().lenght <= 0) {

				// redirect
				window.location.href = $(this).attr("href");

			} else {

				var a = $(this).attr("data-url");

				$.ajax({
					type: "POST",
					url: "/signVerifyBasketCookieServlet/?operation=sign&bankName=" + e,
					success: function () {
						null !== a && (window.location.href = a)
					},
					error: function (e) { console.log(e); }
				})

			}


		});

		// add to cart triggered
		$(document).on('click', "*[data-add-to-cart]", function () {

			basketCookie.addToCart($(this).attr("data-add-to-cart"), $(this).attr("data-category"));

			basketCookie.basketAccordion($(this), "add");

		});

		// add to cart (data-c-cart) triggered
		$(document).on('click', "*[data-c-cart]", function () {

			basketCookie.basketAccordion($(this), "add");

			if (($(this).attr("data-c-cart") !== "") && ($(this).attr("data-category") !== undefined)) {

				//if there is an array of IDS to be deleted
				if (($(this).attr("data-remove-ids") !== undefined) && $(this).attr("data-remove-ids") !== "") {

					var idsArray = JSON.parse($(this).attr("data-remove-ids"));

					idsArray.forEach(function (element) {

						if (element.id !== undefined) {

							basketCookie.removeFromCart("" + element.id, false);
							//remove accountpack
							basketCookie.updateCookie(null, "remove");

						}

					});

				}

				var prodArray = JSON.parse($(this).attr("data-c-cart"));
				var cgryt = $(this).attr("data-category");
				prodArray.forEach(function (element, cgryt) {

					basketCookie.addToCart(JSON.stringify(element), cgryt);

				});

				if (($(this).attr("data-c_accountpack") !== "") && ($(this).attr("data-c_accountpack") !== undefined)) {

					var accountpack = $(this).attr("data-c_accountpack");
					basketCookie.updateCookie(accountpack, "add");

				}

			}

		});

		// delete from cart triggered (by data-remove)
		$(document).on('click', "*[data-remove]", function () {

			basketCookie.basketAccordion($(this), "remove");

			//if there is an array of IDS
			if (($(this).attr("data-remove-ids") !== undefined) && $(this).attr("data-remove-ids") !== "") {

				var idsArray = JSON.parse($(this).attr("data-remove-ids"));

				idsArray.forEach(function (element) {

					if (element.id !== undefined) {

						basketCookie.removeFromCart("" + element.id, false);
						//remove accountpack
						basketCookie.updateCookie(null, "remove");

					}

				});

			} else {

				basketCookie.removeFromCart($(this).attr("data-remove"), false);

			}

		});

		// delete from cart triggered (by data-cancel)
		$(document).on('click', "*[data-cancel]", function () {

			basketCookie.basketAccordion($(this), "remove");

			basketCookie.removeFromCart($(this).attr("data-cancel"), false);

		});


		// add cookie property on click
		$(document).on('click', '*[data-add-cookie-property]', function () {

			var target = $(this);

			// if it's button 'change gift' get data from 'add gift' button
			if (target.hasClass('-js-cart__btnChangeGift')) {
				target = target.siblings('.-js-cart__btnAddGift');
			}

			// parse data
			var data = basketCookie.parseAttributeData(target);

			// set cookie property
			basketCookie.addCookieProperty(data.propertyName, data.propertyValue);

		});


		// remove cookie property on click
		$(document).on('click', '*[data-remove-cookie-property]', function () {

			// get values
			var propertyName = $(this).attr('data-remove-cookie-property');

			// delete cookie property
			basketCookie.deleteCookieProperty(propertyName);

		});

		// enable/disable salary discount and update personalLoanConfiguration cookie property
		$(document).on('click', "*[data-tab]", function (event) {

			var isWithoutSalaryTabOpen = $('*[data-tab="without-salary"]').hasClass('open');

			if (isWithoutSalaryTabOpen) {

				// Disable Salary Discount section
				//basketCookie.disableSalaryDiscount();

				// update personalLoanConfiguration cookie property
				basketCookie.setLoanConfigurationsCookie();

				return;

			}

			// Enable Salary Discount section
			//basketCookie.enableSalaryDiscount();

		});

		// simulate click on the tab withouw salary
		// disable it for cib -- CR 3916
		$(document).on('click', '*[data-trigger-tab]', function () {

			var isCib = $("html").attr("data-bank") == "CIB";

			$(".com16__tabs [data-tab]").removeClass("open");

			if (!isCib){

				if ($(this).attr("data-trigger-tab") == "with-salary") {

					$('li[data-tab="with-salary"]').addClass("open");
					$('td.with-salary').show();
					$('td.without-salary').hide();
					$(".con16-2_tabCircleWrapper").css("display", "block");
					if ($(window).width() < 768) {
						$(this).parents(".tab-mobile").find(".next-btn").attr("onclick", "window.intesa.calculatorNavigation.nextPrev(1, this)");
					}
				}

				if ($(this).attr("data-trigger-tab") == "without-salary") {

					$('li[data-tab="without-salary"]').addClass("open");
					$('td.with-salary').hide();
					$('td.without-salary').show();
					$(".con16-2_tabCircleWrapper").css("display", "none");
					if ($(window).width() < 768) {

						$(this).parents(".tab-mobile").find(".next-btn").attr("onclick", "window.intesa.calculatorNavigation.goToTab(4)");
					}

				}

			} else {
				if ($(this).attr("data-trigger-tab") == "with-salary") {
					$('li[data-tab="with-salary"]').addClass("open");
				}

				if ($(this).attr("data-trigger-tab") == "without-salary") {
					$('li[data-tab="without-salary"]').addClass("open");
				}
			}

		});

	};

	/* --------------------- */


	/**
	 * Parse attribute data
	 *
	 * @param {*} target
	 */
	this.parseAttributeData = function (target) {

		// parse data
		var data = target.attr('data-add-cookie-property');
		data = JSON.parse(data);

		// get values from data
		var propertyName = data.propertyName;
		var propertyValue = data.value;

		return {

			"propertyName": propertyName,
			"propertyValue": propertyValue

		};

	};

	/**
	 * Get product info from 'data-c-mainproduct' data attribute
	 *
	 * @param {*} product Object contaning all the product data
	 */
	this.getProductInfo = function (product) {

		var obj = {};

		if (product) {

			try {
				product = JSON.parse(product);
				obj = {
					'name': product.label,
					'fullPrice': product.fullPrice,
					'discountedPrice': product.discountedPrice,
					'pricingType': product.pricingType
				};
			} catch (e) {
				console.error('Datalayer Parse error: unable to parse "data-c-mainproduct" for this product');
			}

		}

		return obj;

	};

	/**
	 * Manage basket accordions toggle
	 *
	 * @param {*} target
	 */
	this.basketAccordion = function (target, op) {

		var MAIN_OPENED = $("[data-baskettype=MAIN] [aria-expanded=true]");
		var MAIN_CLOSED = $("[data-baskettype=MAIN] [aria-expanded=false]");
		var BUNDLE_PRODUCT_OPENED = $("[data-baskettype=BUNDLE_PRODUCT] [aria-expanded=true]");
		var BUNDLE_PRODUCT_CLOSED = $("[data-baskettype=BUNDLE_PRODUCT] [aria-expanded=false]");
		var CROSSSELLING_OFFER_OPENED = $("[data-baskettype=CROSSSELLING_OFFER] [aria-expanded=true]");
		var CROSSSELLING_OFFER_CLOSED = $("[data-baskettype=CROSSSELLING_OFFER] [aria-expanded=false]");

		if (
			(target !== null) &&
			(target !== undefined) &&
			(target !== "")
		) {

			if (
				(target.attr("data-baskettypebtn") !== undefined > 0) &&
				(target.attr("data-baskettypebtn") !== null) &&
				(target.attr("data-baskettypebtn") !== "")
			) {

				var btnType = target.attr("data-baskettypebtn");

				//add to basket case
				if (op == "add") {

					if (btnType == "CROSSSELLING_PRODUCT") {

						MAIN_CLOSED.trigger("click");

					}

					if (btnType == "BUNDLE_PRODUCT") {

						MAIN_OPENED.trigger("click");

					}

					if (btnType == "CROSSSELLING_OFFER") {

						BUNDLE_PRODUCT_OPENED.trigger("click");
						MAIN_CLOSED.trigger("click");

					}

					if (btnType == "CROSSSELLING_CUSTOME_OFFER") {

						BUNDLE_PRODUCT_OPENED.trigger("click");
						MAIN_OPENED.trigger("click");

					}

				}

				//delete from basket case
				if (op == "remove") {

					if (btnType == "CROSSSELLING_PRODUCT") {

						MAIN_OPENED.trigger("click");

					}

					if (btnType == "BUNDLE_PRODUCT") {

						MAIN_CLOSED.trigger("click");

					}

					if (btnType == "CROSSSELLING_OFFER") {

						MAIN_OPENED.trigger("click");
						BUNDLE_PRODUCT_CLOSED.trigger("click");

					}

					if (btnType == "CROSSSELLING_CUSTOME_OFFER") {

						MAIN_CLOSED.trigger("click");
						BUNDLE_PRODUCT_CLOSED.trigger("click");

					}

				}

			}

		}

	};


	/**
	 * Add cookie property
	 *
	 * @param {*} propertyName
	 * @param {*} value
	 */
	this.addCookieProperty = function (propertyName, value) {

		// log
		console.log("Add cookie property: " + propertyName);

		// get cookie
		var productCookie = basketCookie.getCookie(cookieName);
		productCookie = JSON.parse(productCookie);

		// add new property
		productCookie[propertyName] = value;

		// set cookie
		productCookie = JSON.stringify(productCookie);
		basketCookie.setCookie(cookieName, productCookie, cookieDuration);

	};


	/**
	 * Delete cookie property
	 *
	 * @param {*} propertyName
	 */
	this.deleteCookieProperty = function (propertyName) {

		// log
		console.log("Delete cookie property: " + propertyName);

		// get cookie
		var productCookie = basketCookie.getCookie(cookieName);
		productCookie = JSON.parse(productCookie);

		// delete property
		delete productCookie[propertyName];

		// set cookie
		productCookie = JSON.stringify(productCookie);
		basketCookie.setCookie(cookieName, productCookie, cookieDuration);

	};


	/**
	 * Update cookie with accountOffer
	 * 
	 * @param {*} accountOffer 
	 * @param {*} action 
	 */
	this.updateCookie = function (accountOffer, action) {

		var productCookie = basketCookie.getCookie(cookieName);
		var cookieJSON = JSON.parse(productCookie);

		if ((accountOffer !== "") && (accountOffer !== undefined)) {

			if (accountOffer !== null) {

				accountOffer = JSON.parse(accountOffer);

			}

			if ((action !== "") && (action !== undefined)) {

				if (action == "add") {

					console.log(cookieJSON.accountOffer);
					if (cookieJSON.accountOffer) {

						delete cookieJSON.accountOffer;

					}

					cookieJSON.accountOffer = accountOffer;
					console.log(cookieJSON.accountOffer);

				}

				if (action == "remove") {

					console.log(cookieJSON.accountOffer);
					if (cookieJSON.accountOffer) {

						delete cookieJSON.accountOffer;

					}

					console.log(cookieJSON.accountOffer);

				}

			}

		}

		productCookie = JSON.stringify(cookieJSON);

		basketCookie.setCookie(cookieName, productCookie, cookieDuration);

	};


	/**
	 * Create the cookie
	 *
	 * @param {*} main
	 */
	this.createCookie = function (main) {

		// log
		console.log("Create basket cookie");

		var c_selectedProcess = main.attr("data-c-selectedProcess");
		var c_editLink = main.attr("data-c-editLink");
		var c_mainProduct = main.attr("data-c-mainProduct");
		var c_cart = main.attr("data-c-cart");
		var c_accountPack = main.attr("data-c_accountPack");
		var c_personalLoanConfiguration = main.attr("data-c-personalLoanConfiguration");

		// if personalLoanConfiguration exists
		if ((c_personalLoanConfiguration !== "") && (c_personalLoanConfiguration !== null) && (c_personalLoanConfiguration !== undefined)) {

			var c_persLoanConf = '"personalLoanConfiguration": ' + c_personalLoanConfiguration + ',';
			var c_val = '{"selectedProcess": "' + c_selectedProcess + '","editLink": "' + c_editLink + '",' + c_persLoanConf + '"mainProduct": ' + c_mainProduct + ',"cart": ' + c_cart + '}';

		} else {

			var c_val = '{"selectedProcess": "' + c_selectedProcess + '","editLink": "' + c_editLink + '","mainProduct": ' + c_mainProduct + ',"cart": ' + c_cart + ',"accountOffer": ' + c_accountPack + '}';

		}

		// does the cookie exists? what value does it have?
		var productCookie = basketCookie.getCookie(cookieName);
		if (productCookie != "") {

			// delete the cookie
			basketCookie.deleteCookie(cookieName);

		}

		// (re)create de cookie
		basketCookie.setCookie(cookieName, c_val, cookieDuration);

		localStorage.setItem(cookieName, c_val);
	};

	/**
	 * Get cookie
	 *
	 * @param {*} cname
	 */
	this.getCookie = function (cname) {

		// log
		console.log("Get basket cookie");

		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');

		for (var i = 0; i < ca.length; i++) {

			var c = ca[i];

			while (c.charAt(0) == ' ') {

				c = c.substring(1);

			}

			if (c.indexOf(name) == 0) {

				return base64_decode(c.substring(name.length, c.length)); // decoded from base 64

			}

		}

		return "";

	};

	/**
	 * Set cookie
	 *
	 * @param {*} cname
	 * @param {*} cvalue
	 * @param {*} exdays
	 */
	this.setCookie = function (cname, cvalue, exdays) {

		// log
		console.log("Set basket cookie");
		console.log(cvalue);

		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));

		var expires = "expires=" + d.toGMTString();

		cvalue = base64_encode(cvalue); // encode in base 64

		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

		// basket checkout
		var checkout_btn = $(".btn-checkout");
		if (checkout_btn.length) {

			var url_checkout = checkout_btn.data("url");
			if (url_checkout != null) {

				// checkout_btn.attr( "href", url_checkout + "?product=" + cvalue );

			}

		}

		// save in localstorage
		localStorage.setItem("categoryResumeMap", JSON.stringify(basketCookie.categoryResumeMap));

	};

	/**
	 * Delete cookie
	 *
	 * @param {*} cname
	 */
	this.deleteCookie = function (cname) {

		// log
		console.log("Delete basket cookie");

		document.cookie = cname + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

		// clear localstorage
		basketCookie.categoryResumeMap = new Map();
		localStorage.removeItem("categoryResumeMap");

	};

	/* --------------------- */

	/**
	 * Add to cart
	 *
	 * @param {*} prod
	 * @param {*} cat
	 */
	this.addToCart = function (prod, cat) {

		// log
		console.log("Add product to basket");

		// get cateogry map
		var id_cat_loaded = basketCookie.categoryMap.get(cat);
		if (id_cat_loaded != undefined) {

			basketCookie.removeFromCart(id_cat_loaded, true);

		}

		// does the cookie exists? what value does it have?
		var productCookie = basketCookie.getCookie(cookieName);
		if (productCookie != "") {

			productCookie = JSON.parse(productCookie);
			prod = JSON.parse(prod);

			var idProd = prod.id;

			// check to add the product only once
			var found = productCookie['cart'].some(function (el) {

				return el.id === idProd;

			});

			if (!found) {

				// the product doesn't exists, so it will be added
				productCookie['cart'].push(prod);
				basketCookie.categoryMap.set(cat, idProd);

			}

			productCookie = JSON.stringify(productCookie);

			// (re)create de cookie
			basketCookie.setCookie(cookieName, productCookie, cookieDuration);

		}

	};

	/**
	 * Remove from cart
	 *
	 * @param {*} prod
	 * @param {*} saveRemoved
	 */
	this.removeFromCart = function (prod, saveRemoved) {

		// log
		console.log("Remove product from basket");
		console.log(basketCookie.categoryMap);

		// set category key
		var catKey = undefined;

		// get cateogry map
		basketCookie.categoryMap.forEach(function (value, key, map) {

			if (value == prod) {

				basketCookie.categoryMap.delete(key);
				catKey = key;

			}

		});

		// does the cookie exists? what value does it have?
		var productCookie = basketCookie.getCookie(cookieName);
		if (productCookie != "") {

			productCookie = JSON.parse(productCookie);
			prod = parseInt(prod);

			for (var i = 0; i < productCookie['cart'].length; i++) {

				if (productCookie['cart'][i]['id'] == prod) {

					if (saveRemoved && catKey != undefined) {

						basketCookie.categoryResumeMap.set(catKey, JSON.stringify(productCookie['cart'][i]));

					}

					productCookie['cart'].splice(i, 1);

				}

			}

			productCookie = JSON.stringify(productCookie);

			// (re)create de cookie
			basketCookie.setCookie(cookieName, productCookie, cookieDuration);

		}

		// check element to ripristinate
		if (!saveRemoved && catKey != undefined) {

			// log
			console.log(basketCookie.categoryResumeMap);
			console.log(catKey);

			// get cateogry map
			basketCookie.categoryResumeMap.forEach(function (value, key, map) {

				if (key == catKey) {

					basketCookie.addToCart(basketCookie.categoryResumeMap.get(key), catKey);

				}

			});

		}

	};

	/**
	 * Set Loan Configurations Cookie
	 *
	 *
	 */
	this.setLoanConfigurationsCookie = function () {

		// get values from DOM
		var monthlyInstallment = $('[data-algoritmresult="monthlyInstallmentStandard"]').text();
		var interestRate = $('[data-algoritmresult="interestRateStandard"]').text();
		var apr = $('[data-algoritmresult="aprStandard"]').text();

		// format values
		monthlyInstallment = monthlyInstallment.replace(/\s/g, '');
		interestRate = interestRate.replace(',', '.');
		apr = apr.replace(',', '.');

		try {

			// get cookie inside data-attr
			var attrConf = $('*[data-generate-cookie]').attr('data-c-personalloanconfiguration');
			attrConf = JSON.parse(attrConf);

			// set updated values
			attrConf.INSTALLMENT = monthlyInstallment;
			attrConf.INTERESTRATE = interestRate;
			attrConf.APR = apr;
			attrConf.DISCOUNTCODE = ''; // clear discount code

			// update cookie inside data-attr
			$('*[data-generate-cookie]').attr('data-c-personalloanconfiguration', JSON.stringify(attrConf));

		} catch (err) {

			console.log('[data-generate-cookie] doesn\'t exists or it\'s not a valid JSON');

		}

	};

	/**
	 * Disable Salary Discount
	 *
	 *
	 */
	this.disableSalaryDiscount = function () {

		// get current option id
		var previousSalaryCode = $('.con16-2_tabCircleWrapper .com16-2__tabItem.active').attr('data-salary-code');

		// remove active class from every circle
		$('.con16-2_tabCircleWrapper .com16-2__tabItem').removeClass('active');

		// set disable css style parent element
		var parent = $('.con16-2_tabCircleWrapper').parent();

		parent.css({
			'opacity': 0.4,
			'position': 'relative'
		});

		// append absolute div to disable click & on hover events
		parent.append('<div class="input-shield" data-prev="' + previousSalaryCode + '" style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; z-index: 9999;"></div>');

	};

	/**
	 * Enable Salary Discount
	 *
	 *
	 */
	this.enableSalaryDiscount = function () {

		var inputShield = $('.input-shield');

		// get previous active circle ID
		var prev = inputShield.attr('data-prev');

		// remove absolute div that disable click
		inputShield.remove();
		$('.con16-2_tabCircleWrapper').parent().removeAttr('style');

		// trigger click on last active circle
		$('[data-salary-code="' + prev + '"]').trigger('click');

	};

};

/**
 * Get class instance
 *
 */
Intesa.BasketCookie.getInstance = function () {

	if (!window.intesa) {

		window.intesa = new Object();

	}
	if (!window.intesa.basket_cookie) {

		window.intesa.basket_cookie = new Intesa.BasketCookie();

	}

	return window.intesa.basket_cookie;

};

/**
 * On DOM ready
 *
 */
// $( document ).ready( function() {
/* document.addEventListener( "DOMContentLoaded", function() {

	// init component
	var basketCookie = Intesa.BasketCookie.getInstance();
	basketCookie.init();

} ); */
